export enum PerDizzleFeatureFlags {
    SeamlessRebooking = 'seamless-rebooking',
    FixRejectedByInPdSubmittal = 'fix-rejected-by-in-pd-submittal',
    MoveAddShiftToSidePanel = 'MOVE_ADD_SHIFT_TO_SIDE_PANEL',
    NovaShiftDetailActions = 'nova-shift-detail-actions',
    EnableCustomizedProfessionsForNovaShift = 'enable-customized-professions-for-nova-shift',
    EnableAssignNursWithFacilityAvailability = 'enable-assign-nurse-with-facility-availability',
    EnableShiftParTags = 'enable-shift-par-tags',
    EnablePdRecruiterShiftHistoryLinks = 'enable-pd-recruiter-shift-history-links'
}
